import {
    NEWSLOADING,
    NEWSSUCCESS,
    NEWSERROR,
} from "../actionTypes";
const init_state = {
    data: [],
    error: false,
    loading: false
}
export const newsReducer = (state = init_state, {
    type,
    payload
}) => {
    switch (type) {
      
        case NEWSSUCCESS:
            
            return {
                ...state,
                loading: false,
                data: payload,
                error: false

            }
            case NEWSERROR:
                return {
                    ...state,
                    loading: false,
                        error: true,
                        
                }
                case NEWSLOADING:
                    return {
                        ...state,
                            loading: true,
                            error: false,
                           
                    }
                
                        default:
                            return state
    }
}